import {Component, state, style, trigger} from "@angular/core";
import {MatDialogRef} from "@angular/material";
import {StateService} from "../../service/state";
import {ApiService} from "../../service/api";
import {User} from "../../data/user";

@Component({
    selector: 'app-login-dialog',
    templateUrl: './login.dialog.html',
    styleUrls: ['./login.dialog.scss'],
    animations: [
        trigger('wobble', [
            state('true', style({
                animation: 'shake 0.82s cubic-bezier(.36,.07,.19,.97) both',
                transform: 'translate3d(0, 0, 0)',
                'backface-visibility': 'hidden',
                perspective: '1000px'
            }))
        ])
    ]
})
export class LoginDialogComponent {
    public error;
    public wobbleState = false;

    public username;
    public password;

    constructor(public dialog: MatDialogRef<LoginDialogComponent>, protected state: StateService, protected api: ApiService) {
    }

    login() {
        this.wobbleState = false;
        this.error = '';

        this.api.call('/index/login/login', {
            username: this.username,
            password: this.password
        }).then((result) => {
            let user: User = result;
            this.state.setState('user', user);
            this.dialog.close();
        }).catch((result) => {
            let status = JSON.parse(result.statusText);

            this.error = status.message;
            this.wobbleState = true;
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.dialog.ts